export default {
	QuickAddText: 'Add new (F9)',
	QuickSearchText: 'Quick search (F3)',
	NumberPerPage: 'records on',
	Page: 'page',
	First: 'Initial',
	Previous: 'Front',
	Of: 'of',
	Next: 'After',
	Latest: 'Last',
	TotalItem: 'Total number of records',
	TotalItemV1: 'Total number',
	TotalInvoice: 'Total number of invoices',
	ValidateLengthPassword: 'At least 8 characters',
	ValidateTextPassword: 'Match upper/lower case',
	ValidateNumberPassword: 'contains at least 1 digit',
	ExpiredDateUseFrom: 'Expiry date',
	NumberInvoiceStill: 'Invoices left',
	TourGuide: {
		Guide1:
			'You send or forward an invoice email to this email address. The system will automatically look up and process invoice',
		Guide2:
			'The input invoice will be stored here. You can view the invoice processing results, export to import into accounting software',
		Guide3: 'Manage the list of receiving invoice companies, branches, departments'
	},
	FileProcess: {
		here: 'In here',
		HandInput: 'Not yet entered data',
		FileYetProcess: count =>
			`There are ${count} unprocessed invoices. The program process XML invoices best. Please download XML invoice to check`,
		InvoiceYetInput: count => `There are ${count} invoices remaining have not been entered data yet`
	},
	Pagination: { Total: 'Total', record: 'records', to: 'to' },
	Notification: {
		NotificationNewForYou: numberNotification => `You have just received ${numberNotification} new notifications`
	},
	Popup: { Guide: 'Help' },
	Progress: {
		Readied: 'Ready',
		fail: 'failed',
		Preparing: 'Preparing',
		DownloadReady: 'Ready to download',
		DownloadFail: 'Download failed',
		DownloadPrepare: 'Preparing to download'
	},
	Combobox: { NotData: 'No data found' },
	Sidebar: {
		TitleStep2Bank: 'Invoice',
		TitleStep3Bank: 'Organizational structure',
		TitleStep2Normal: 'Input invoice',
		TitleStep3Normal: 'Output invoice',
		TitleStep4Normal: 'Customs declaration',
		TitleStep5Normal: 'Organizational structure',
		TitleStep6Normal: 'Connect to Tax Authority',

		// For organizations WITH special characteristics (Banks/Insurance/Auditing)
		Step2Bank:
			'Invoices will be stored here. You can view invoice processing results, export to import into accounting software.',
		Step3Bank: linkhelp =>
			`<div style='margin-bottom: 8px'>Manage the list of companies, branches, departments receiving invoices.</div><div>If you want to check invoices of your organization, set up the organizational structure according to the guide <a style='color: #00AAB7' href=${linkhelp} target="_blank">here</a>.</div>`,

		// For organizations WITHOUT special characteristics
		Step2Normal:
			'Input invoices will be stored here. You can view invoice processing results, export to import into accounting software.',
		Step3Normal:
			'Output invoices will be stored here. Each output invoice added to the program will be charged like an input invoice.',
		Step4Normal:
			'Import customs declarations will be stored here. You can view declaration reading results and export excel reports of declarations.',
		Step5Normal: linkhelp =>
			`<div style='margin-bottom: 8px'>Manage the list of companies, branches, departments receiving invoices.</div><div>If you act as a bank, insurance company, auditing company, need to check invoices of other parties, set up the organizational structure according to the guide <a style='color: #00AAB7' href=${linkhelp} target="_blank">here</a>.</div>`,
		Step6Normal:
			'Connect with the tax authority right here to synchronize and process invoices automatically every day.',
		// Backward compatibility
		Step2:
			'The input invoice will be stored here. You can view the invoice processing results, export to import into accounting software.',
		Step3: 'Manage the list of receiving invoice companies, branches, departments',

		// PBI-548352: Third Party Organization Mode Indicator
		ThirdPartyCheckMode: 'Using software to check third party invoices'
	},

	HeaderOptionFilter: {
		Filter: 'Filter',
		UnFilter: 'Clear filters',
		Cancel: 'Cancel',
		InputEmptyText: 'Input filter value ',
		InputValueFrom: 'Filter value from',
		InputValueTo: 'to',
		Status: 'Checking result',
		Sticks: 'Sticker',
		TypeInvoiceReceive: 'Invoice Source',
		StatusInvoice: 'Status',
		StatusView: 'Viewing Status',
		InvoiceNo: 'InvoiceNo',
		AmountPayment: 'Payment Status',
		CheckedVatStatus: 'Check Tax rate',
		HasPdf: 'Invoice representation',
		HasXml: 'Invoice xml',
		SupplierCode: 'Unit code',
		SellerName: 'Supplier',
		SellerAddress: 'Address supplier',
		SellerTaxCode: 'Taxcode supplier',
		TemplateNo: 'TemplateNo',
		Series: 'Series',
		TotalAmount: 'Total amount',
		CcyCode: 'Currency',
		ExchangeRate: 'ExchangeRate',
		TotalAmountExchange: 'Total amount exchange',
		PaymentNumber: 'Number of payments',
		TotalAmountNotPayment: 'Unpaid money',
		BuyerName: 'Buyer unit name ',
		BuyerAddress: 'Buyer address',
		Noted: 'Note',
		RefNo: 'Document number',
		Accountant: 'Accounting person',
		LicensePlate: 'License plates',
		SignedDate: 'Signe date',
		IssueDate: 'IssueDate',
		CheckDate: 'CheckDate',
		KindAccountingDate: 'Accounting status',
		InfoND123: {
			BuyerFullName: 'Buyer name'
		},
		SellerRiskStatus: 'Risk status',
		CostType: 'Cost type',
		BeyondTheNorm: 'Beyond the norm',
		CostNorms: 'Cost norms',
		DeclarationNo: 'Customs Declaration No.',
		ExporterName: 'Exporter',
		TotalDeclarationAmount: 'Tổng trị giá hóa đơn'
	}
};
